import type { User } from "@shared/schema";
import { detectUserCountry } from "@/lib/countryDetection";

const FALLBACK_COUNTRY_BY_LOCALE: Record<string, string> = {
  nl: "NL",
  en: "UK",
  "en-gb": "UK",
  de: "DE",
  fr: "FR",
  es: "ES",
  it: "IT",
  da: "DK",
  sv: "SE",
};

const US_STATE_REGEX = /\b(AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY)\b/i;

function parseCountryFromProfile(user?: User | null): string | null {
  if (!user) return null;
  const text = `${user.homeAddress || ""} ${user.homeCity || ""}`.toLowerCase();
  if (!text.trim()) return null;

  if (text.includes("netherlands") || text.includes("nederland")) return "NL";
  if (text.includes("belgium") || text.includes("belgie") || text.includes("belgië")) return "BE";
  if (text.includes("france") || text.includes("frankrijk")) return "FR";
  if (text.includes("germany") || text.includes("deutschland") || text.includes("duitsland")) return "DE";
  if (text.includes("denmark") || text.includes("denemarken")) return "DK";
  if (text.includes("sweden") || text.includes("zweden")) return "SE";
  if (text.includes("united kingdom") || text.includes("england") || text.includes("scotland") || text.includes("wales")) return "UK";
  if (text.includes("united states") || text.includes("usa")) return "US";
  if (text.includes("canada")) return "CA";
  return null;
}

function parseUsStateFromProfile(user?: User | null): string | null {
  if (!user) return null;
  const text = `${user.homeAddress || ""} ${user.homeCity || ""}`.toUpperCase();
  const match = text.match(US_STATE_REGEX);
  return match?.[1] || null;
}

export function getPreferredGeo(user: User | null | undefined, locale: string) {
  const profileCountry = parseCountryFromProfile(user);
  const country = profileCountry || detectUserCountry() || FALLBACK_COUNTRY_BY_LOCALE[locale] || "NL";
  const stateOrProvince = country === "US" ? parseUsStateFromProfile(user) : null;
  return { country, stateOrProvince };
}

